/* eslint-disable import/no-anonymous-default-export */
import * as actions from './actions';

export type State = {
  currentView: string;
  pageStack: Array<string>;
  overriddenEventsData?: Array<Record<string, any>>;
  tempScenario: Record<string, any>;
  modelledScenario: Record<string, any>;
  selectedEvent: Record<string, any>;
  updatedFields: Record<string, any>;
  // accountHolderOptions: Array<Record<string, string>>;
};

const initialState = {
  currentView: '',
  pageStack: [],
  tempScenario: {},
  modelledScenario: {},
  selectedEvent: {},
  updatedFields: {},
  // accountHolderOptions: [],
};

export default (state: State = initialState, action: any = {}): State => {
  switch (action.type) {
    case actions.SET_INITIAL_STATE_FOR_INCOME_EVENTS:
      return {
        ...state,
        tempScenario: {
          ...action.payload,
        },
        modelledScenario: {
          ...action.payload,
        },
        updatedFields: {},
      };
      case actions.SET_INCOME_ACCOUNT_HOLDER_OPTIONS:
        return {
          ...state,
          ...action.payload,
        };
      case actions.SET_SELECTED_INCOME_EVENT:
        return {
          ...state,
          selectedEvent: action.payload,
        };
      case actions.UPDATE_SELECTED_INCOME_EVENT:
        return {
          ...state,
          selectedEvent: {
            ...state.selectedEvent,
            ...action.payload,
          },
        };
      case actions.CURRENT_VIEW:
        if (state.currentView && action.payload) {
          state.pageStack.push(state.currentView);
        }
        const currentView = action.payload ? action.payload : state.pageStack.length ? state.pageStack.pop() : '';
        return {
          ...state,
          currentView,
        };
      case actions.CLEAN_UP:
        return {
          ...state,
          currentView: '',
          pageStack: [],
        };
      case actions.UPDATE_INCOME_EVENT_DATA:
        return {
          ...state,
          tempScenario: {
            ...action.payload,
          },
          updatedFields: {
            ...state.updatedFields,
            ...action.payload,
        },
        };
      case actions.MODEL_INCOME_EVENTS_DATA:
          return {
            ...state,
            modelledScenario: {
              ...action.payload,
            },
            updatedFields: {
              ...state.updatedFields,
              ...action.payload,
          },
          };
        // case actions.OVERRIDE_ACCOUNTS_DATA:
        //   return {
        //     ...state,
        //     overridenAccountsData: action.payload,
        //   };
        default:
          return state;
  }
}

